import { React, useEffect, useState, api, API_URL, toast, PuffLoader, override } from "../../../services/common";
import { Card } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import profile from "../../../assets/images/profile.svg";
import classcount from "../../../assets/images/class-count.svg";
import MainHeader from "../../Common/Header/MainHeader/MainHeader";
import { Helmet } from "react-helmet";
import "./CourseList.css";



const CourseList = () => {
    const [loading, setLoading] = useState(false);
    const [courses, setCourses] = useState([]);
    const courseSchema = [
        {
            "@context": "https://schema.org",
            "@type": "Course",
            "name": "Singing Course",
            "description": "Master the art of singing with our professional tutors. Learn vocal techniques, pitch control, and explore various genres of music.",
            "provider": {
                "@type": "EducationalOrganization",
                "name": "Music Seekho",
                "url": "https://musicseekho.com"
            },
            "educationalLevel": "Beginner to Advanced",
        },
        {
            "@context": "https://schema.org",
            "@type": "Course",
            "name": "Keyboard Course",
            "description": "Learn to play the keyboard with comprehensive lessons covering chords, scales, and accompaniment techniques.",
            "provider": {
                "@type": "EducationalOrganization",
                "name": "Music Seekho",
                "url": "https://musicseekho.com"
            },
            "educationalLevel": "Beginner to Advanced",
        },
        {
            "@context": "https://schema.org",
            "@type": "Course",
            "name": "Guitar Course",
            "description": "Develop your guitar skills with expert guidance. Learn strumming, fingerpicking, and play your favorite songs.",
            "provider": {
                "@type": "EducationalOrganization",
                "name": "Music Seekho",
                "url": "https://musicseekho.com"
            },
            "educationalLevel": "Beginner to Advanced",
        }
    ];
    const navigate = useNavigate();

    const viewSelectedCourse = (tutorId, course, courseName) => {
        navigate(`/courses/${tutorId}/${course}`, { state: { courseName: courseName } });
    }

    const viewCourses = () => {
        setLoading(true);
        api.get(API_URL + '/tutors/view-tutors').then((response) => {
            setLoading(false);
            const tutorsData = response.data;
            const allCourses = tutorsData.reduce((courses, tutor) => {
                const tutorCourses = tutor?.courses?.map(course => ({
                    ...course,
                    tutor_id: tutor.id,
                    tutor: tutor.name
                }));
                if (!tutorCourses || tutorCourses.length === 0) {
                    return courses; // Skip if no courses
                }
                return [...courses, ...tutorCourses];
            }, []);
            setCourses(allCourses);
        }).catch((error) => {
            setLoading(false);
            toast.error(error?.response?.data?.message || error.message);;
            console.log(error);
        });
    }

    useEffect(() => {
        viewCourses();
    }, []);


    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(courseSchema)}
                </script>
            </Helmet>
            <MainHeader></MainHeader>
            <div className="tutor-list">
                {courses.map((course, index) => (
                    <div key={index}>
                        <Card className="tutor-cards" onClick={() => viewSelectedCourse(course?.tutor_id, course?.id, course?.name)}>

                            <Card.Img className="tutor-image" variant="left" src={course?.image || 'https://firebasestorage.googleapis.com/v0/b/musicapp-backend-5878b.appspot.com/o/placeholder.jpg?alt=media&token=f59e4d05-d1e7-4d92-bffa-c27b1ca6941b'} />
                            <Card.Body>
                                <Card.Title className="tutor-name">
                                    <span className="ellipsis-text">
                                        {course?.name.length > 30 ? `${course?.name.substring(0, 30)}...` : course?.name}
                                    </span>
                                </Card.Title>
                                <Card.Title >
                                    <img className="tutor-icons" src={profile} alt="Profile of the user"></img>
                                    <span className="tutor-details">{course?.tutor}</span>
                                </Card.Title>
                                <Card.Title>
                                    <img className="tutor-icons student-icon" src={classcount} alt="Class Count"></img>
                                    <span className="tutor-details">{course?.students || 0} students </span>
                                </Card.Title>
                                <div className="view-more">View More</div>
                            </Card.Body>
                        </Card>
                    </div>
                ))}
            </div>
            <PuffLoader loading={loading} cssOverride={override} color="#7F56D9" />
        </>
    )
}

export default CourseList
